module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "Basic-Paragraph para-style-override-4"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-4"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "frame-2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "frame-3",
    attrs: {
      "alt": "Confederacy%27s%20First%20Battle%20Flag%20No%20Author.jpg",
      "src": "Images/Confederacy%27s%20First%20B_fmt3.jpeg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a39026e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/HalfTitle2.vue
// module id = 75
// module chunks = 0